import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { PRIORITY_CONFIG, Priority } from '../../types/work';

interface Props {
  priority: Priority;
}

export const PriorityChip: React.FC<Props> = ({ priority }) => {
  const { darkMode } = useTheme();
  const config = PRIORITY_CONFIG[priority] || PRIORITY_CONFIG.medium;
  const classes = darkMode ? config.dark : config.light;
  return (
    <span className={`inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded text-xs font-medium ${classes}`}>
      <span className="text-[10px]">{config.icon}</span>
      {priority}
    </span>
  );
};
